export default __webpack_public_path__ + "static/media/hbs-cbb-banner-3.f1dd30de.jpg";